import React from "react";

const BottomLeftCorner = ({ color }) => {
  return (
    <div style={{ width: "4rem", height: "4rem" }} className="corner">
      <div
        style={{
          height: "2.5rem",
          width: "6px",
          backgroundColor: color !== undefined ? color : "#EEEEEE",
          marginLeft: "1rem",
        }}
      ></div>
      <div
        style={{
          height: "6px",
          width: "4rem",
          backgroundColor: color !== undefined ? color : "#EEEEEE",
        }}
      ></div>
      <div
        style={{
          height: "1rem",
          width: "6px",
          backgroundColor: color !== undefined ? color : "#EEEEEE",
          marginLeft: "1rem",
        }}
      ></div>
    </div>
  );
};

export default BottomLeftCorner;
